<!--Coming soon starts-->
<section id="coming-soon">
  <div class="container-fluid">
    <div class="row auth-height full-height-vh">
      <div class="col-12 d-flex align-items-center justify-content-center">
        <div class="card card-coming-soon box-shadow-0 overflow-hidden">
          <div class="card-header text-center pt-4 pb-3">
            <img alt="avtar" class="img-fluid" src="assets/img/gallery/coming-soon.png" width="200">
          </div>
          <div id="clockFlat" class="getting-started px-sm-2">
            <div class="clockCard d-inline-block text-center px-3 px-sm-4 py-3">
              <span>{{ countdown.days }}</span>
              <br>
              <p class="lead m-0">Days</p>
            </div>
            <div class="clockCard d-inline-block text-center px-3 px-sm-4 py-3">
              <span>{{ countdown.hours }}</span>
              <br>
              <p class="lead m-0">Hours</p>
            </div>
            <div class="clockCard d-inline-block text-center px-3 px-sm-4 py-3">
              <span>{{ countdown.minutes }}</span>
              <br>
              <p class="lead m-0">Minutes</p>
            </div>
            <div class="clockCard d-inline-block text-center px-3 px-sm-4 py-3">
              <span>{{ countdown.seconds }}</span>
              <br>
              <p class="lead m-0">Seconds</p>
            </div>
          </div>
          <div class="card-content">
            <div class="card-body text-center pt-1">
              <h2 class="mb-4 mt-2">We Are Launching Soon.</h2>
              <div class="mx-4">
                <div class="input-group">
                  <input type="text" class="form-control" placeholder="Email" aria-describedby="coming-soon-subscribe">
                  <div class="input-group-append">
                    <button type="button" class="btn btn-primary" id="coming-soon-subscribe">
                      <i class="ft-log-in d-sm-none font-medium-2"></i>
                      <span class="d-none d-sm-block">Subscribe</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Coming soon ends-->
